import { render, staticRenderFns } from "./SplitSection.vue?vue&type=template&id=c748f7ae&"
import script from "./SplitSection.vue?vue&type=script&lang=js&"
export * from "./SplitSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports